/**
 * A global namespace for `document.documentElement` or the `<HTML>`.
 */
const { documentElement } = document;
export default documentElement;
